import type { ComponentProps } from "react";

import { cn } from "./cn";

/**
 * The visible label of a control. Tie it with `htmlFor`. `required` adds a " *" for the eye only. It is a CSS pseudo-element with an empty
 * alternative text, so it is not part of the accessible name or of the text of the label ("Name", not "Name *"). The control itself
 * carries the `required` attribute, so a screen reader still says it is required.
 */
export function Label({
  className,
  required = false,
  ...props
}: ComponentProps<"label"> & Readonly<{ required?: boolean | undefined }>) {
  return (
    // biome-ignore lint/a11y/noLabelWithoutControl: a generic label; the caller ties it to its control with `htmlFor`
    <label
      data-required={required ? "true" : undefined}
      className={cn(
        "block text-[13px] leading-[18px] font-semibold text-foreground data-[required=true]:after:content-['_*'_/_'']",
        className,
      )}
      {...props}
    />
  );
}
